/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "transfer",

    getDefaultProps: function getDefaultProps() {
        return {
            "transfer": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "57.9",
            "height": "54.4"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 57.9 54.4", className: "transfer", width: this.props.width, height: this.props.height, style: this.props.transfer },
            _react2["default"].createElement("path", { fill: "#999", d: "M27.2 17.9V0L0 27.2l27.2 27.2V36.5h30.7V17.9z" })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/transfer.js